import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  ChartBarIcon, 
  UserGroupIcon, 
  BuildingOfficeIcon, 
  CreditCardIcon,
  FolderIcon,
  UserIcon,
  BellIcon,
  HeartIcon,
  ChartPieIcon,
  CogIcon,
  EnvelopeIcon,
  TagIcon,
  ListBulletIcon,
  ArrowTrendingUpIcon,
  AcademicCapIcon,
  CircleStackIcon,
  FunnelIcon,
  BeakerIcon,
  KeyIcon,
  CodeBracketIcon,
  LinkIcon,
  CpuChipIcon,
  ChatBubbleLeftRightIcon,
  SparklesIcon,
  PresentationChartLineIcon,
} from '@heroicons/react/24/outline'

const Sidebar: React.FC = () => {
  const location = useLocation()
  
  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: ChartBarIcon },
    { name: 'Users', href: '/users', icon: UserGroupIcon },
    { name: 'Organizations', href: '/organizations', icon: BuildingOfficeIcon },
    { name: 'Projects', href: '/projects', icon: FolderIcon },
    { name: 'Members', href: '/members', icon: UserIcon },
    { name: 'Invitations', href: '/invitations', icon: EnvelopeIcon },
    { name: 'Guest Tours', href: '/guest-tours', icon: AcademicCapIcon },
    { name: 'Billing', href: '/billing', icon: CreditCardIcon },
    { name: 'Expansion Requests', href: '/expansion-requests', icon: ArrowTrendingUpIcon },
    { name: 'Discount Codes', href: '/discount-codes', icon: TagIcon },
    { name: 'Notifications', href: '/notifications', icon: BellIcon },
    { name: 'System Health', href: '/health', icon: HeartIcon },
    { name: 'Analytics', href: '/analytics', icon: ChartPieIcon },
    { name: 'Metrics', href: '/metrics', icon: PresentationChartLineIcon },
    { name: 'Onboarding', href: '/onboarding', icon: FunnelIcon },
    { name: 'Trial Analytics', href: '/trial-analytics', icon: BeakerIcon },
    { name: 'Mo Analytics', href: '/check-analytics', icon: BeakerIcon },
    { name: 'Motiocomp Analytics', href: '/motiocomp-analytics', icon: BeakerIcon },
    { name: 'Integrations', href: '/integrations', icon: LinkIcon },
    { name: 'Client Proposals', href: '/client-proposals', icon: KeyIcon },
    { name: 'Dev Handoffs', href: '/dev-handoffs', icon: CodeBracketIcon },
    { name: 'AI Scout', href: '/ai-scout', icon: CpuChipIcon },
    { name: 'Motionode AI', href: '/motionode-ai', icon: ChatBubbleLeftRightIcon },
    { name: 'Model Performance', href: '/model-performance', icon: SparklesIcon },
    { name: 'Mo Evals', href: '/mo_evals', icon: BeakerIcon },
    { name: 'Reassignment Monitor', href: '/queue-monitoring', icon: ListBulletIcon },
    { name: 'Database', href: '/database', icon: CircleStackIcon },
    { name: 'Settings', href: '/settings', icon: CogIcon },
  ]

  const isActiveRoute = (href: string) => {
    return location.pathname === href
  }

  return (
    <div className="w-64 shrink-0 bg-white border-r border-gray-200 flex flex-col sticky top-0 h-screen overflow-y-auto">
      <div className="p-6">
        <h2 className="text-xl font-bold text-gray-900">Motionode Admin</h2>
      </div>
      <nav className="flex-1 px-4 pb-4 space-y-1">
        {navigation.map((item) => {
          const Icon = item.icon
          return (
            <Link
              key={item.name}
              to={item.href}
              className={`
                group flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors
                ${isActiveRoute(item.href)
                  ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-500'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                }
              `}
            >
              <Icon className="mr-3 h-5 w-5 flex-shrink-0" />
              {item.name}
            </Link>
          )
        })}
      </nav>
    </div>
  )
}

export default Sidebar 